export const GOLF_SWIPE_INTENT_PX = 10
export const GOLF_DELETE_REVEAL_PX = 80

export function golfDeleteRevealStyle(offset = 0) {
  const revealPx = Math.max(0, -(Number(offset) || 0))
  const progress = Math.min(1, revealPx / GOLF_DELETE_REVEAL_PX)
  return { opacity: progress, visibility: progress === 0 ? 'hidden' : 'visible', pointerEvents: progress === 1 ? 'auto' : 'none', clipPath: `inset(0 0 0 ${100 - progress * 100}%)`, '--reveal-progress': progress }
}
export const GOLF_SWIPE_DISTANCE_PX = 64
export const GOLF_SWIPE_VELOCITY_PX_MS = 0.45

export function golfHoleSlideDepth({ index, dragX, viewportWidth, reduceMotion = false }) {
  if (reduceMotion) return 1
  const progress = Math.min(1, Math.abs(dragX) / Math.max(1, viewportWidth))
  if (index === 1) return 1 - (.015 * progress)
  if (dragX < 0) return index === 2 ? .985 + (.015 * progress) : 1
  if (dragX > 0) return index === 0 ? .985 + (.015 * progress) : 1
  return .985
}

export function selectGolfViewingHole({ target, canEdit, onSelect, onPersist }) {
  onSelect(target)
  if (canEdit) onPersist(target)
}

export function resolveGolfSwipe({ deltaX, deltaY, elapsed, currentHole, holeCount }) {
  if (Math.abs(deltaX) < GOLF_SWIPE_INTENT_PX || Math.abs(deltaX) <= Math.abs(deltaY)) return currentHole
  const velocity = Math.abs(deltaX) / Math.max(elapsed, 1)
  if (Math.abs(deltaX) < GOLF_SWIPE_DISTANCE_PX && velocity < GOLF_SWIPE_VELOCITY_PX_MS) return currentHole
  return Math.max(1, Math.min(holeCount, currentHole + (deltaX < 0 ? 1 : -1)))
}
